import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { T, alpha } from './poyais-ui/theme';

const API = (window as any).ENV_API_URL || 'https://app.poyaisone.com/api/v1';

function LogoHeader() {
  return (
    <div style={{ textAlign: 'center', marginBottom: 28 }}>
      <img src="/poyais-halka.png" width={52} height={52} alt="Poyais One"
        style={{ display: 'inline-block' }} />
      <div style={{ color: T.accent, fontSize: 11, fontWeight: 700,
        letterSpacing: 3, marginTop: 8, textTransform: 'uppercase' as const }}>
        Poyais One
      </div>
    </div>
  );
}

function GucMetre({ sifre }: { sifre: string }) {
  const kontroller = [
    { etiket: 'En az 10 karakter', tamam: sifre.length >= 10 },
    { etiket: 'Büyük harf', tamam: /[A-Z]/.test(sifre) },
    { etiket: 'Rakam', tamam: /[0-9]/.test(sifre) },
  ];
  const puan = kontroller.filter(k => k.tamam).length;
  const renkler = [T.red, T.amber, T.green];
  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', gap: 4, marginBottom: 6 }}>
        {[0,1,2].map(i => (
          <div key={i} style={{ flex: 1, height: 4, borderRadius: 2,
            background: i < puan ? renkler[puan - 1] : T.border,
            transition: 'background 0.3s' }} />
        ))}
      </div>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' as const }}>
        {kontroller.map(k => (
          <span key={k.etiket} style={{ fontSize: 11, color: k.tamam ? T.greenText : T.textFaint }}>
            {k.tamam ? '✓' : '○'} {k.etiket}
          </span>
        ))}
      </div>
    </div>
  );
}

export default function SetPasswordPage() {
  const params  = new URLSearchParams(window.location.search);
  const token   = params.get('token') || '';

  const [ad, setAd]               = useState('');
  const [email, setEmail]         = useState('');
  const [tokenDurumu, setTokenDurumu] = useState<'yukleniyor'|'gecerli'|'gecersiz'>('yukleniyor');
  const [tokenHata, setTokenHata] = useState('');
  const [sifre, setSifre]         = useState('');
  const [tekrar, setTekrar]       = useState('');
  const [goster, setGoster]       = useState(false);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [basarili, setBasarili]   = useState(false);
  const [hata, setHata]           = useState('');

  useEffect(() => {
    if (!token) {
      setTokenDurumu('gecersiz');
      setTokenHata('Geçersiz bağlantı. Lütfen yöneticinizle iletişime geçin.');
      return;
    }
    axios.get(`${API}/auth/check-set-token?token=${token}`)
      .then(r => { setTokenDurumu('gecerli'); setAd(r.data.name || ''); setEmail(r.data.email || ''); })
      .catch(e => { setTokenDurumu('gecersiz'); setTokenHata(e.response?.data?.detail || 'Geçersiz veya süresi dolmuş bağlantı.'); });
  }, [token]);

  const gonder = async () => {
    setHata('');
    if (sifre.length < 10 || !/[A-Za-zÇĞİÖŞÜçğıöşü]/.test(sifre) || !/[0-9]/.test(sifre)) { setHata('Şifre en az 10 karakter olmalı ve en az bir harf ile bir rakam içermelidir.'); return; }
    if (sifre !== tekrar)  { setHata('Şifreler eşleşmiyor.'); return; }
    setYukleniyor(true);
    try {
      await axios.post(`${API}/auth/set-password`, { token, password: sifre });
      setBasarili(true);
      setTimeout(() => { window.location.href = '/'; }, 3500);
    } catch (e: any) {
      setHata(e.response?.data?.detail || 'Bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setYukleniyor(false);
    }
  };

  const bg: React.CSSProperties = {
    minHeight: '100vh',
    background: `linear-gradient(135deg,${T.ink} 0%,#2a2d2e 50%,${T.ink} 100%)`,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '24px 16px', fontFamily: 'Manrope, sans-serif',
  };
  const kart: React.CSSProperties = {
    background: T.surface, borderRadius: 20, padding: '40px 36px',
    width: '100%', maxWidth: 440, boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  };
  const etiket: React.CSSProperties = {
    display: 'block', fontSize: 13, fontWeight: 600, color: T.text, marginBottom: 6,
  };
  const girdi: React.CSSProperties = {
    width: '100%', padding: '11px 14px', border: `1.5px solid ${T.border}`,
    borderRadius: 8, fontSize: 14, color: T.text, outline: 'none',
    boxSizing: 'border-box', fontFamily: 'Manrope, sans-serif',
  };
  const hataKutu: React.CSSProperties = {
    background: 'var(--py-red-tint)', border: `1px solid ${alpha(T.red, 25)}`, borderRadius: 8,
    padding: '12px 14px', fontSize: 13, color: T.redText, marginBottom: 16,
  };
  const buton: React.CSSProperties = {
    width: '100%', padding: 14, background: yukleniyor ? T.accentDeep : T.accent,
    color: T.accentInk, border: 'none', borderRadius: 10, fontSize: 15,
    fontWeight: 700, cursor: yukleniyor ? 'not-allowed' : 'pointer',
    marginTop: 4, fontFamily: 'Manrope, sans-serif', transition: 'background 0.2s',
  };

  if (tokenDurumu === 'yukleniyor') return (
    <div style={bg}><div style={kart}><LogoHeader />
      <p style={{ textAlign: 'center', color: T.textDim, fontSize: 14 }}>Bağlantı doğrulanıyor...</p>
    </div></div>
  );

  if (tokenDurumu === 'gecersiz') return (
    <div style={bg}><div style={kart}><LogoHeader />
      <div style={{ background: 'var(--py-red-tint)', border: `1px solid ${alpha(T.red, 25)}`, borderRadius: 10, padding: '20px 24px', textAlign: 'center', marginBottom: 20 }}>
        <div style={{ fontSize: 36, marginBottom: 10 }}>⚠️</div>
        <h2 style={{ fontSize: 18, fontWeight: 700, color: T.text, margin: '0 0 8px' }}>Geçersiz Bağlantı</h2>
        <p style={{ fontSize: 14, color: 'var(--py-text-mid-alt)', margin: 0 }}>{tokenHata}</p>
      </div>
      <p style={{ fontSize: 13, color: T.textDim, textAlign: 'center' }}>
        Sorun yaşıyorsan{' '}
        <a href="mailto:hello@poyaisone.com" style={{ color: T.accent, textDecoration: 'none', fontWeight: 600 }}>
          hello@poyaisone.com
        </a>{' '}
        adresine yazabilirsin.
      </p>
    </div></div>
  );

  if (basarili) return (
    <div style={bg}><div style={kart}><LogoHeader />
      <div style={{ textAlign: 'center', padding: '8px 0 24px' }}>
        <div style={{ fontSize: 52, marginBottom: 16 }}>✅</div>
        <h2 style={{ fontSize: 20, fontWeight: 800, color: T.text, margin: '0 0 10px' }}>
          Şifreniz Başarıyla Belirlendi!
        </h2>
        <p style={{ fontSize: 14, color: 'var(--py-text-mid-alt)', margin: '0 0 24px', lineHeight: 1.7 }}>
          Birkaç saniye içinde giriş ekranına yönlendiriliyorsun...
        </p>
        <div style={{ width: '100%', height: 4, background: T.border, borderRadius: 2, overflow: 'hidden' }}>
          <div style={{ width: '100%', height: '100%', background: T.accent, borderRadius: 2,
            animation: 'ilerleme 3.5s linear forwards' }} />
        </div>
        <style>{`@keyframes ilerleme { from { transform: scaleX(0); transform-origin: left } to { transform: scaleX(1); transform-origin: left } }`}</style>
      </div>
    </div></div>
  );

  return (
    <div style={bg}>
      <div style={kart}>
        <LogoHeader />
        <h1 style={{ fontSize: 20, fontWeight: 800, color: T.text, margin: '0 0 6px', textAlign: 'center' }}>
          Poyais One&apos;a Hoş Geldin!
        </h1>
        <p style={{ fontSize: 14, color: 'var(--py-text-mid-alt)', textAlign: 'center', margin: '0 0 24px', lineHeight: 1.7 }}>
          {ad ? <>Merhaba <strong>{ad}</strong>, şifreni belirle ve başla.</> : 'Hesabına erişmek için şifreni belirle.'}
        </p>

        {email && (
          <div style={{ marginBottom: 16 }}>
            <label style={etiket}>E-posta</label>
            <div style={{ ...girdi, background: 'var(--py-subtle-bg)', color: T.textDim }}>{email}</div>
          </div>
        )}

        <div style={{ marginBottom: 16 }}>
          <label style={etiket}>Yeni Şifre</label>
          <div style={{ position: 'relative' }}>
            <input type={goster ? 'text' : 'password'} value={sifre}
              onChange={e => setSifre(e.target.value)}
              placeholder="En az 10 karakter" style={girdi}
              onKeyDown={e => e.key === 'Enter' && gonder()} />
            <button onClick={() => setGoster(!goster)} style={{
              position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
              background: 'none', border: 'none', cursor: 'pointer', color: T.textDim, fontSize: 12, fontWeight: 600
            }}>{goster ? 'Gizle' : 'Göster'}</button>
          </div>
        </div>

        <div style={{ marginBottom: 4 }}>
          <label style={etiket}>Şifre Tekrar</label>
          <input type={goster ? 'text' : 'password'} value={tekrar}
            onChange={e => setTekrar(e.target.value)}
            placeholder="Şifreni tekrar gir" style={girdi}
            onKeyDown={e => e.key === 'Enter' && gonder()} />
        </div>

        {sifre.length > 0 && <GucMetre sifre={sifre} />}
        {hata && <div style={hataKutu}>{hata}</div>}

        <button onClick={gonder} disabled={yukleniyor} style={buton}>
          {yukleniyor ? 'Kaydediliyor...' : 'Şifremi Belirle & Giriş Yap →'}
        </button>

        <p style={{ fontSize: 12, color: T.textFaint, textAlign: 'center', marginTop: 20 }}>
          Sorun yaşıyorsan{' '}
          <a href="mailto:hello@poyaisone.com" style={{ color: T.accent, textDecoration: 'none' }}>
            hello@poyaisone.com
          </a>
        </p>
      </div>
    </div>
  );
}
